import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const ComboboxContainer = styled.div`
  display: flex;
  width: 200px;
  height: 220px;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  background-color: white;
  box-shadow: var(--alias-style-shadow-strong);
  top: 38px;
  left: 0;
  overflow: hidden;
  border-radius: 0px 0px 8px 8px;
  z-index: 100;
`;

export const TextFieldContainer = styled.div`
  display: flex;
  padding: 6px;
`;

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 180px;
  overflow-y: auto;
  background: var(--alias-color-background-normal-normal);
  box-sizing: border-box;
  width: 100%;
`;

export const DropdownItemContainer = styled.div`
  display: flex;
  padding: 8px 12px;
  height: 38px;
  box-sizing: border-box;
  align-items: center;
  align-self: stretch;
  width: 100%;

  cursor: pointer;
  &:hover {
    background: var(--component-color-fill-normal);
  }
`;
